import { render, staticRenderFns } from "./lecturer-you-are-meeting-host-dialog.vue?vue&type=template&id=259bb23a&scoped=true"
import script from "./lecturer-you-are-meeting-host-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./lecturer-you-are-meeting-host-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./lecturer-you-are-meeting-host-dialog.vue?vue&type=style&index=0&id=259bb23a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259bb23a",
  null
  
)

export default component.exports